<template>
		<div class="conxq">
			<div class="conxq_top">
				<div class="conxq_top_sosuo">
					<img src="../../assets/images/licai/fanhui.png">
					<div class="conxq_top_search">
						<input class="" placeholder=""/>
					</div>
				</div>
			</div>
			<div class="conxq_mid">
				<div class="conxq_mid_top">
					<p class="conxq_mid_top_tit">东财新能源车</p>
					<p class="conxq_mid_top_txt">申购代码：010805</p>
				</div>
				<div class="conxq_mid_top" style="margin-top:20px">
					<div class="conxq_mid_top_left">
						<p class="conxq_mid_top_left_tit">0.81%</p>
						<p class="conxq_mid_top_left_txt">日回报率</p>
					</div>
					<div class="conxq_mid_top_right">
						<p class="conxq_mid_top_right_tit">无限制</p>
						<p class="conxq_mid_top_left_txt">1个持仓日    起投360-360</p>
					</div>
				</div>
				<div class="conxq_mid_right">
					<p class="">安选</p>
					<div class="conxq_mid_right_block">
						<img src="../../assets/images/licai/zq.png">
						<p class="">精选优质资产</p>
					</div>
					<div class="conxq_mid_right_block">
						<img src="../../assets/images/licai/zq.png">
						<p class="">严控回撤</p>
					</div>
					<div class="conxq_mid_right_block">
						<img src="../../assets/images/licai/zq.png">
						<p class="">收益稳健</p>
					</div>
				</div>
			</div>
			<div class="conxq_quxian">
				<p class="">涨幅度</p>
				<img src="../../assets/images/licai/quxian.jpg">
			</div>
			<div class="conxq_ld">
				<p class="conxq_ld_tit">产品亮点</p>
				<div class="conxq_ld_block">
					<img src="../../assets/images/licai/jisuan.png">
					<div class="conxq_ld_block_list">
						<p class="conxq_ld_block_list_tit">次日起息, 节假日通用</p>
						<p class="conxq_ld_block_list_txt">建仓成功后每日计算收益，到期后可随时提取</p>
					</div>
				</div>	
				<div class="conxq_ld_block">
					<img src="../../assets/images/licai/fangxin.png">
					<div class="conxq_ld_block_list">
						<p class="conxq_ld_block_list_tit">第三方担保，本金保障</p>
						<p class="conxq_ld_block_list_txt">建仓成功后每日计算收益，到期后可随时提取</p>
					</div>
				</div>
				<div class="conxq_ld_block">
					<img src="../../assets/images/licai/zoushi.png">
					<div class="conxq_ld_block_list">
						<p class="conxq_ld_block_list_tit">运作稳健</p>
						<p class="conxq_ld_block_list_txt">精选固定收益资产，严格控制回撤，有专业更有价值</p>
					</div>
				</div>
					
			</div>
			<div class="conxq_xq">
				<div class="conxq_xq_top">
					<p class="conxq_xq_top_p">产品详情</p>
					<p class="conxq_xq_top_p">金额收益计算规则</p>
					<p class="conxq_xq_top_p">资金去向</p>
				</div>
				<div class="conxq_xq_bot">
					<div class="conxq_xq_bot_list">
						<p class="conxq_xq_bot_list_tit">项目名称</p>
						<p class="conxq_xq_bot_list_txt">指数型：东财新能源车A</p>
					</div>
					<div class="conxq_xq_bot_list">
						<p class="conxq_xq_bot_list_tit">项目进度</p>
						<p class="conxq_xq_bot_list_txt">20.56%</p>
					</div>
					<div class="conxq_xq_bot_list">
						<p class="conxq_xq_bot_list_tit">剩余余额</p>
						<p class="conxq_xq_bot_list_txt">95323680</p>
					</div>
					<div class="conxq_xq_bot_list">
						<p class="conxq_xq_bot_list_tit">日化回报率</p>
						<p class="conxq_xq_bot_list_txt">0.81%</p>
					</div>
					<div class="conxq_xq_bot_list">
						<p class="conxq_xq_bot_list_tit">限投次数</p>
						<p class="conxq_xq_bot_list_txt">限投1次</p>
					</div>
					<div class="conxq_xq_bot_list">
						<p class="conxq_xq_bot_list_tit">招募周期</p>
						<p class="conxq_xq_bot_list_txt">无限制</p>
					</div>
					<div class="conxq_xq_bot_list">
						<p class="conxq_xq_bot_list_tit">担保公司</p>
						<p class="conxq_xq_bot_list_txt">中国太平洋集团有限公司</p>
					</div>
				</div>
			</div>
			<div class="conxq_gz">
				<div class="conxq_gz_tit">交易规则</div>
				<img src="../../assets/images/licai/1631293376.png">
				<div class="conxq_gz_list">
					<div class="conxq_gz_list_block">
						<p class="conxq_gz_list_block_line"></p>
						<p class="conxq_gz_list_block_txt">保障计划专款第三方监督</p>
					</div>
					<div class="conxq_gz_list_block">
						<p class="conxq_gz_list_block_line"></p>
						<p class="conxq_gz_list_block_txt">身份证与数字人民币绑定，只能绑定本人名下的数字人民币</p>
					</div>
					<div class="conxq_gz_list_block">
						<p class="conxq_gz_list_block_line"></p>
						<p class="conxq_gz_list_block_txt">先行赔付计划：
							投资者加入360理财欺诈推广全赔计划后，如因通过360理财平台推广买到恶意欺诈产品从而
							导致直接财产损失的，360将承担先行赔付责任。
						</p>
					</div>
					<div class="conxq_gz_list_block">
						<p class="conxq_gz_list_block_line"></p>
						<p class="conxq_gz_list_block_txt">先行赔付计划：投资者加入360理财欺诈推广全赔计划后，
							如因通过360理财平台推广买到恶意欺诈产品从而导致直接财产损失的，360将承担先行赔付责任。
					</p>
					</div>
				</div>
			</div>
			<button class="conxq_but" @click="">马上建仓</button>
		</div>
</template>
<script>
	import {
		getSpreadInfo,
		getTzInfo
	} from "../../api/user";
	import Loading from "@components/Loading";

	export default {
		name: "touZiList",
		components: {
			Loading
		},
		props: {},
		data: function() {
			return {
				info: [],
				extractCount: 0,
				where: {
					page: 1,
					limit: 3
				},
				types: 4,
				loaded: false,
				loading: false
			};
		},
		mounted: function() {
			this.getCommission();
			this.getIndex();
			this.$scroll(this.$refs.container, () => {
				this.loading === false && this.getIndex();
			});
		},
		filters: {
			formatDate: function(value) {
				var date = new Date(value * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				var D = date.getDate() + ' ';
				var h = date.getHours() + ':';
				var m = date.getMinutes() + ':';
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
				console.log(Y + M + D + h + m + s)
			}
		},
		methods: {
			getIndex: function() {
				// this.loading = true;
				getTzInfo().then(
					res => {
						console.log(res.data)
						this.info = res.data[0]
					},
					error => {
						console.log(222222)
					}
				);
			},
			getCommission: function() {
				let that = this;
				getSpreadInfo().then(
					res => {
						that.extractCount = res.data.extractCount;
					},
					error => {
						this.$dialog.message(error.msg);
					}
				);
			}
		}
	};
</script>
<style type="text/css">
	.conxq{
		padding-bottom: 30px;
	}
	.conxq_xq_top{
		display: flex;
		align-items: center;
	}
	.conxq_but{
		width: 100%;
		height: 40px;
		line-height: 40px;
		text-align: center;
		color: #fff;
		font-size: 16px;
		margin-top: 20px;
		background-color: #ff1900;

	}
	.conxq_gz img{
		width: 100%;
	}
	.conxq_gz_list_block{
		display: flex;
		align-items: center;
		margin-top: 15px;
	}
	.conxq_gz_list_block_txt{
		font-size: 14px;
		color: #999;
		width: 90%;
		margin-left: 10px;
	}
	.conxq_gz_list{
		margin-top: 20px;
	}
	.conxq_gz_list_block_line{
		width: 10px;
		height: 10px;
		background-color: #ff1900;
		border-radius: 50%;
	}
	.conxq_gz{
		background-color: #fff;
		padding: 15px;
		width: 92%;
		margin: 0 auto;
		margin-top: 15px!important;
	}
	.conxq_xq_bot_list_tit{
		font-size: 14px;
		color: #666;
	}
	.conxq_xq_top .conxq_xq_top_p:nth-child(2){
		width: 50%;
	}
	.conxq_xq_top_p{
		width: 25%;
	}
	.conxq_xq_bot_list_txt{
		margin-left: auto;
		font-size: 15px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 50px;
	}
	.conxq_xq_bot{
		margin-top: 15px;
	}
	.conxq_xq_bot_list{
		display: flex;
		align-items: center;
	}
	.conxq_xq_top p{
		text-align: center;
		font-size: 18px;
	}
	.conxq_xq{
		margin-top: 15px!important;
		background-color: #fff;
		padding: 15px;
		border-radius: 10px;
		width: 92%;
		margin: 0 auto;
	}
	.conxq_ld_block_list{
		margin-left: 15px;
	}
	.conxq_ld_block_list_tit{
		font-size: 18px;
    	color: #000;
	}
	.conxq_ld_block_list_txt{
		font-size: 14px;
    	color: #999;
	}
	.conxq_ld_tit{
		font-size: 16px;
    	color: #000;
	}
	.conxq_ld_block{
		display: flex;
		align-items: center;
		margin-top: 15px;
	}
	.conxq_ld_block img{
		width: 35px;
	}
	.conxq_ld{
		width: 92%;
		margin: 0 auto;
		background-color: #fff;
		border-radius: 10px;
		margin-top: 15px!important;
		padding: 15px;
	}
	.conxq_quxian{
		width: 100%;
		background-color: #fff;
		margin-top: 15px!important;
		padding: 15px;
		width: 92%;
		margin: 0 auto;
		border-radius: 10px;
	}
	.conxq_quxian img{
		width: 100%;
	}
	.conxq_quxian p{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #110E0E;
		line-height: 20px;
	}
	.conxq_mid_right{
		display: flex;
		align-items: center;
		margin-top: 20px;
	}
	.conxq_mid_right_block{
		display: flex;
		align-items: center;
		margin-left: 15px;
	}
	.conxq_mid_right_block img{
		width: 15px;
		height: 15px;
	}
	.conxq_mid_right_block p{
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
	}
	.conxq_top_search{
	background: linear-gradient(93deg, #FFFFFF 0%, #ff6b5a 0%, #ff1900 0%, #ff1900 100%);
		border-radius: 20px;
		height: 30px;
		width: 90%;
		display: flex;
		align-items: center;
		padding-left: 15px;
	}
	.conxq_top_search input{
		color: #fff;
	}
	.conxq_mid_top_left{
		width: 46%;
	}
	.conxq_mid_top_left_tit{
		font-size: 20px;
		color: #CF4948;
	}
	.conxq_mid_top_left_txt{
		font-size: 12px;
    	color: #999;
	}
	.conxq_mid_top_right_tit{
		font-size: 20px;
		color: #333;
	}
	.conxq_mid_top{
		display: flex;
    	align-items: center;
	}
	.conxq_mid_top_tit{
		font-size: 21px;
    	color: #000;
	}
	.conxq_mid_top_txt{
		background-color: #FF6000;
		color: #fff;
		border-radius: 5px;
		padding: 2px 10px;
		margin-left: 10px;
	}
	.conxq_mid{
		background-color: #FFFFFF;
		border-radius: 15px;
		width: 92%;
		margin: 0 auto;
		padding: 15px;
		margin-top: -25px;
	}
	.conxq_top_sosuo{
		display: flex;
		align-items: center;
		height: 30px;
	}
	.conxq_top_sosuo img{
		width: 27px;
		height: 23px;
	}
	.conxq_top{
		width: 100%;
		height: 201px;
	background: linear-gradient(93deg, #ff6b5a 0%, #ff1900 100%);
		padding-top: 15px;
	}
	.name {
		font-size: 0.48rem;
		;
	}

	/* 清除浮动*/
	.am-fl {
		float: left
	}

	.am-fr {
		float: right
	}

	.am-cf:after {
		content: "";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
	}

	.am-cf {
		zoom: 1;
	}

	.list {
		padding: 0 12px;
	}

	.listn {
		margin: 12px 0px;
		border-radius: 8px;
		background-image: linear-gradient(to right, #efdada, red);
		padding: 8px 0px;
	}

	.listn_s {
		width: 100%;
		padding: 0 15px;
	}

	.listn_s p {
		width: 50%;
		line-height: 28px;
	}

	.listn_d {
		padding: 0 15px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.zong {
		width: 48%;
		display: flex;
		align-items: center;
		background-color: #fff;
		margin-right: 4%;
		padding: 8px;
		border-radius: 5px;
		margin-top: 8px;
	}

	.zong:nth-child(2n) {
		margin-right: 0px
	}

	.listn_d div img {
		width: 30px;
		margin-right: 12px;
	}

	.listn_d div p {
		text-align: center;
	}

	.time {
		text-align: right;
		color: #fff;
	}
</style>
